// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"6cf76e9f","154":"1c301173","207":"e44d82d3","220":"646b4cea","233":"dda49187","453":"20359781","975":"3ea311fb"}[chunkId] + ".chunk.js";
};